module.exports = __webpack_public_path__ + "img/koe2-5.88b4ac7b.jpg";